/**
 * Determines the current environment based on the URL
 */
export function getEnvironment(): 'dev' | 'magiclegs' | 'production' {
  if (typeof window === 'undefined') {
    return 'production';
  }

  const currentOrigin = window.location.origin;

  if (
    currentOrigin.includes('localhost') ||
    currentOrigin.includes('127.0.0.1') ||
    currentOrigin.includes('//dev.')
  ) {
    return 'dev';
  }

  if (currentOrigin.includes('//magiclegs.')) {
    return 'magiclegs';
  }

  return 'production';
}
